import React from 'react';
import QuestionWrapper from '../response/QuestionWrapper';
const NotificationQuestion = props => (
  <QuestionWrapper {...props} thumbSize="large" />
);
export default NotificationQuestion;
